export const ADD_JOB = "ADD_JOB";
export const SET_JOBS = "SET_JOBS";
export const UPDATE_JOB = "UPDATE_JOB";
export const DELETE_JOB = "DELETE_JOB";
export const SET_JOB_LABELS = "SET_JOB_LABELS";
export const JOB_LOADING = "JOB_LOADING";
export const SET_JOB_COMPANIES = "SET_JOB_COMPANIES";
